export default __webpack_public_path__ + "report-bi.266a1efeab9a893d2732a6e6cbf8caf6.svg";